import http from '../../HttpConfig'
import {APIS_ENDPOINTS} from '../../SERVICE-CONSTANTS'

const letter_endpoints = APIS_ENDPOINTS.archiveddocument

export interface ICreateArchivedDocumentPayload {
  Id?: number
  Files: File[]
  Title: string
  DocumentNumber: string
  Type: number
  DocumentDate: string
  Summary: string
  Name: string
  Code: string
  Address: string
  Tag: string
  IsArchived: boolean
}
export const request_create = async ({
  Files,
  Address,
  Code,
  DocumentDate,
  DocumentNumber,
  IsArchived,
  Name,
  Summary,
  Tag,
  Title,
  Type,
}: ICreateArchivedDocumentPayload) => {
  const formData = new FormData()
  if (Files.length !== 0) {
    for (var i = 0; i < Files.length; i++) {
      formData.append('IFile', Files[i])
    }
  }
  formData.append('Address', Address ?? '')
  formData.append('Code', Code ?? '')
  formData.append('DocumentDate', DocumentDate ?? '')
  formData.append('DocumentNumber', DocumentNumber ?? '')
  formData.append('IsArchived', String(IsArchived ?? false))
  formData.append('Name', Name ?? '')
  formData.append('Summary', Summary ?? '')
  formData.append('Tag', Tag ?? '')
  formData.append('Title', Title ?? '')
  formData.append('Type', String(Type ?? 0))
  return http.post(letter_endpoints.create, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export const request_edit = async ({
  Files,
  Address,
  Code,
  DocumentDate,
  DocumentNumber,
  IsArchived,
  Name,
  Summary,
  Tag,
  Title,
  Type,
  Id
}: ICreateArchivedDocumentPayload) => {
  const formData = new FormData()
  if (Files.length !== 0) {
    for (var i = 0; i < Files.length; i++) {
      formData.append('IFile', Files[i])
    }
  }
  formData.append('Id', Id?.toString() ?? '')
  formData.append('Address', Address ?? '')
  formData.append('Code', Code ?? '')
  formData.append('DocumentDate', DocumentDate ?? '')
  formData.append('DocumentNumber', DocumentNumber ?? '')
  formData.append('IsArchived', String(IsArchived ?? false))
  formData.append('Name', Name ?? '')
  formData.append('Summary', Summary ?? '')
  formData.append('Tag', Tag ?? '')
  formData.append('Title', Title ?? '')
  formData.append('Type', String(Type ?? 0))
  return http.put(letter_endpoints.edit, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export const request_getAll = async ({
  search,
  CurrentPage,
  PageSize,
}: {
  search?: string
  CurrentPage: number
  PageSize: number
}) => {
  return http.get(
    letter_endpoints.datatable +
      `?CurrentPage=${CurrentPage}&PageSize=${PageSize}${search ? `&search=${search}` : ''}`
  )
}

export const request_detail = async (id: number) => {
  return http.get(letter_endpoints.detail + `?id=${id}`)
}


export const request_deletefile = async (id: number) => {
  return http.delete(letter_endpoints.deletefile + `?id=${id}`)
}
